import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const EMP_INFO = 'Emp-Info'
const USER_AUTH = 'user-auth'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function setEmpInfo (emp) {
  return localStorage.setItem(EMP_INFO, emp)
}

export function removeEmpInfo () {
  return localStorage.removeItem(EMP_INFO)
}

export function getEmpInfo () {
  const item = localStorage.getItem(EMP_INFO)
  if (item) {
    return JSON.parse(item)
  } else {
    return item
  }
}
export function setUserPermissions (permissions) {
  return localStorage.setItem(USER_AUTH, permissions)
}
export function getUserPermissions (enName) {
  const item = localStorage.getItem(USER_AUTH)
  if (item) {
    const permissionsData = JSON.parse(item)
    if (permissionsData[enName]) {
      return permissionsData[enName]
    } else {
      return false
    }
  } else {
    return false
  }
}
